// Configuração do quiz gamificado — MF Lançamentos
// Substituir dados fictícios pelos reais quando o cliente enviar

export const QUESTIONS = [
  {
    id: 'location',
    title: 'Qual localização você prefere?',
    subtitle: 'Escolha a região ideal para você',
    options: [
      { value: 'alphaville', label: 'Alphaville' },
      { value: 'tambore', label: 'Tamboré' },
      { value: 'barueri-centro', label: 'Barueri Centro' },
    ]
  },
  {
    id: 'profile',
    title: 'Qual o seu perfil?',
    subtitle: 'Isso nos ajuda a encontrar a melhor opção',
    options: [
      { value: 'moradia', label: 'Moradia' },
      { value: 'investimento', label: 'Investimento' },
      { value: 'ambos', label: 'Ambos' },
    ]
  },
  {
    id: 'size',
    title: 'Tamanho desejado?',
    subtitle: 'Selecione o que mais combina com você',
    options: [
      { value: 'studio', label: 'Studio / 1 quarto' },
      { value: '2-quartos', label: '2 quartos' },
      { value: '3-quartos', label: '3+ quartos' },
    ]
  }
];

// Empreendimentos fictícios — substituir pelos reais
export const EMPREENDIMENTOS = [
  {
    id: 'living-alphaville',
    name: 'Living Alphaville',
    description: 'Apartamentos modernos com lazer completo no coração de Alphaville.',
    image: '/mf-lancamentos/emp-placeholder.jpg',
    location: 'alphaville',
    profiles: ['moradia', 'investimento', 'ambos'],
    sizes: ['2-quartos', '3-quartos'],
    whatsappNumber: '5511999999999',
    highlight: 'Entrega 2026',
  },
  {
    id: 'vista-tambore',
    name: 'Vista Tamboré',
    description: 'Condomínio cercado de natureza com vista panorâmica.',
    image: '/mf-lancamentos/emp-placeholder.jpg',
    location: 'tambore',
    profiles: ['moradia', 'ambos'],
    sizes: ['3-quartos'],
    whatsappNumber: '5511999999999',
    highlight: 'Alto padrão',
  },
  {
    id: 'smart-barueri',
    name: 'Smart Barueri',
    description: 'Studios e apartamentos compactos ideais para investimento.',
    image: '/mf-lancamentos/emp-placeholder.jpg',
    location: 'barueri-centro',
    profiles: ['investimento', 'ambos'],
    sizes: ['studio', '2-quartos'],
    whatsappNumber: '5511999999999',
    highlight: 'A partir de R$ 199mil',
  },
  {
    id: 'park-alphaville',
    name: 'Park Alphaville',
    description: 'Residencial com área verde e infraestrutura completa.',
    image: '/mf-lancamentos/emp-placeholder.jpg',
    location: 'alphaville',
    profiles: ['moradia', 'ambos'],
    sizes: ['2-quartos', '3-quartos'],
    whatsappNumber: '5511999999999',
    highlight: 'Pronto para morar',
  },
  {
    id: 'compact-tambore',
    name: 'Compact Tamboré',
    description: 'Apartamentos inteligentes com ótima rentabilidade.',
    image: '/mf-lancamentos/emp-placeholder.jpg',
    location: 'tambore',
    profiles: ['investimento', 'ambos'],
    sizes: ['studio', '2-quartos'],
    whatsappNumber: '5511999999999',
    highlight: 'Lançamento',
  },
];

// Lógica de matching — retorna empreendimentos compatíveis
export function matchEmpreendimentos(answers) {
  const { location, profile, size } = answers;

  // Match exato (3/3 critérios)
  const exact = EMPREENDIMENTOS.filter(emp =>
    emp.location === location &&
    emp.profiles.includes(profile) &&
    emp.sizes.includes(size)
  );

  if (exact.length > 0) return exact;

  // Match parcial (2/3 critérios), ordenado por relevância
  const partial = EMPREENDIMENTOS
    .map(emp => {
      let score = 0;
      if (emp.location === location) score++;
      if (emp.profiles.includes(profile)) score++;
      if (emp.sizes.includes(size)) score++;
      return { ...emp, score };
    })
    .filter(emp => emp.score >= 2)
    .sort((a, b) => b.score - a.score);

  if (partial.length > 0) return partial;

  // Se nada bateu, retorna todos
  return EMPREENDIMENTOS;
}

// Mapeamento de vídeos dinâmicos por resposta
// Após responder Q1 (location), a transição 2 muda. Após Q2 (profile), a transição 3 muda.
export const DYNAMIC_VIDEOS = {
  // Pergunta 0 (location) → define vídeo do índice 1 (transição 2)
  0: {
    'alphaville': '/mf-lancamentos/transicao_2_alphaville.mp4',
    'tambore': '/mf-lancamentos/transicao_2_tambore.mp4',
    'barueri-centro': '/mf-lancamentos/transicao_2_barueri.mp4',
  },
  // Pergunta 1 (profile) → define vídeo do índice 2 (transição 3)
  // Mapeado por LOCALIZAÇÃO (quiz 0), não por perfil — usa a resposta armazenada
  1: {
    'alphaville': '/mf-lancamentos/transicao_3_alphaville.mp4',
    'tambore': '/mf-lancamentos/transicao_3_tambore.mp4',
    'barueri-centro': '/mf-lancamentos/transicao_3_barueri.mp4',
  },
};

// Webhook placeholder — substituir pelo endpoint real do CRM
export const WEBHOOK_URL = 'https://webhook-editor.abianca.com.br/webhook/PLACEHOLDER-MF-LANCAMENTOS';

// WhatsApp fallback
export const WHATSAPP_DEFAULT = '5511999999999';
export const WHATSAPP_MESSAGE = 'Olá! Vim pelo site da MF Lançamentos e gostaria de saber mais sobre os empreendimentos.';
